export const translations = {
  fr: {
    // Header
    home: 'Accueil',
    destinations: 'Destinations',
    airlines: 'Compagnies',
    services: 'Services',
    contact: 'Contact',
    about: 'À propos',
    payments: 'Paiements',
    bookNow: 'Réserver maintenant',
    
    // Testimonials
    testimonialsBadge: 'Témoignages',
    testimonialsTitle: 'Ils nous font confiance',
    testimonialsSubtitle: 'Découvrez les expériences de nos clients qui voyagent avec IZI Travels',
    leaveReviewCTA: 'Laissez un avis',
    leaveReviewHelp: 'Vous avez voyagé avec nous ? Partagez votre expérience en quelques secondes.',
    reviewModalTitle: 'Partagez votre expérience',
    reviewModalSubtitle: 'Votre avis aide d\'autres voyageurs à nous découvrir',
    reviewRating: 'Note',
    reviewName: 'Votre nom',
    reviewTrip: 'Votre voyage',
    reviewEmail: 'Email',
    reviewMessage: 'Votre témoignage',
    reviewSubmit: 'Envoyer mon avis',
    reviewSubmitting: 'Envoi en cours...',
    reviewModerationNote: 'Votre avis sera publié après validation par notre équipe.',
    reviewThanksTitle: 'Merci !',
    reviewThanksMsg: 'Votre avis a bien été envoyé. Il sera publié après validation par notre équipe.',
    optional: 'optionnel',
    close: 'Fermer',
    
    // Hero
    premiumAgency: 'Agence de Voyage Premium',
    heroTitle: 'Voyagez partout dans le monde avec',
    heroSubtitle: 'Billets nationaux et internationaux — toutes destinations, toutes compagnies aériennes.',
    discoverDestinations: 'Découvrir les destinations',
    
    // Destinations
    ourDestinations: 'Nos Destinations',
    destinationsSubtitle: 'Explorez toutes les destinations possibles — nationales, africaines et internationales',
    all: 'Toutes',
    national: 'Nationales',
    african: 'Africaines',
    international: 'Internationales',
    
    // Airlines
    ourPartners: 'Nos Compagnies Partenaires',
    airlinesSubtitle: 'Nous travaillons avec les meilleures compagnies aériennes pour vous offrir un service de qualité',
    moreAirlines: 'Et bien d\'autres compagnies aériennes desservant l\'Aéroport International de Ndjili',
    
    // Services
    ourServices: 'Nos Services',
    servicesSubtitle: 'Une gamme complète de services pour rendre votre expérience de voyage exceptionnelle',
    service1Title: 'Réservation de billets d\'avion',
    service1Desc: 'Réservez vos billets nationaux et internationaux en toute simplicité',
    service2Title: 'Voyages nationaux et internationaux',
    service2Desc: 'Accédez à toutes les destinations du monde entier',
    service3Title: 'Assistance voyage',
    service3Desc: 'Un accompagnement personnalisé à chaque étape de votre voyage',
    service4Title: 'Conseils et accompagnement',
    service4Desc: 'Des experts à votre écoute pour planifier votre voyage parfait',
    service5Title: 'Réservations rapides',
    service5Desc: 'Un processus de réservation simple et efficace',
    service6Title: 'Service client réactif',
    service6Desc: 'Disponibles 7j/7 pour répondre à vos questions',
    
    // Booking Form
    bookYourTrip: 'Réservez votre voyage',
    bookingSubtitle: 'Remplissez le formulaire ci-dessous et notre équipe vous contactera rapidement',
    tripType: 'Type de voyage',
    oneWay: 'Aller simple',
    roundTrip: 'Aller-retour',
    multiCity: 'Multi-destination',
    fullName: 'Nom complet',
    email: 'Email',
    phone: 'Téléphone',
    fromCity: 'Ville de départ',
    toCity: 'Ville de destination',
    departureDate: 'Date de départ',
    returnDate: 'Date de retour',
    yourRequest: 'Votre demande',
    sendRequest: 'Envoyer la demande',
    namePlaceholder: 'Votre nom',
    emailPlaceholder: 'votre@email.com',
    phonePlaceholder: '+243 XXX XXX XXX',
    fromPlaceholder: 'Ex: Kinshasa',
    toPlaceholder: 'Ex: Paris',
    messagePlaceholder: 'Décrivez vos besoins de voyage...',
    successMessage: 'Demande envoyée avec succès! Nous vous contacterons bientôt.',
    
    // Passengers
    passengers: 'Passagers',
    adults: 'Adultes',
    adultsDesc: '12 ans et plus',
    children: 'Enfants',
    childrenDesc: '2 à 11 ans',
    infants: 'Bébés',
    infantsDesc: 'Moins de 2 ans',
    minAdultError: 'Au moins un adulte est requis',
    maxAdultError: 'Maximum 9 adultes par réservation',
    infantsExceedError: 'Le nombre de bébés ne peut pas dépasser le nombre d\'adultes',
    childrenNeedAdultError: 'Les enfants doivent voyager avec un adulte',
    
    // Multi-city fields
    flight: 'Vol',
    from: 'De',
    to: 'Vers',
    date: 'Date',
    addFlight: 'Ajouter un vol',
    removeFlight: 'Retirer le vol',
    
    // Contact
    contactUs: 'Contactez-nous',
    contactSubtitle: 'Notre équipe est à votre disposition pour répondre à toutes vos questions',
    address: 'Adresse',
    telephone: 'Téléphone',
    
    // Footer
    tagline: 'Votre porte vers le monde. Voyagez avec confiance et style.',
    quickLinks: 'Liens Rapides',
    ourServicesFooter: 'Nos Services',
    nationalTickets: 'Billets Nationaux',
    internationalTickets: 'Billets Internationaux',
    travelAssistance: 'Assistance Voyage',
    personalizedAdvice: 'Conseils Personnalisés',
    quickBooking: 'Réservation Rapide',
    allRightsReserved: 'Tous droits réservés.',
    footerSignature: 'IZI Travels — Votre porte vers le monde.',

    // About
    aboutBadge: 'Notre histoire',
    aboutTitle: 'À propos de IZI Travels',
    aboutSubtitle: 'Plus de deux décennies d\'expertise au service de vos voyages',
    yearsExperience: 'Années d\'expérience',
    clientsServed: 'Clients satisfaits',
    destinationsCount: 'Destinations',
    airlinePartners: 'Compagnies partenaires',
    ourStoryTitle: 'Une expertise éprouvée depuis plus de 20 ans',
    ourStoryP1: 'L\'agence de voyage IZI Travels existe depuis plus de 20 ans, initialement sous la dénomination de BM Travels et opérant aujourd\'hui sous le nom de IZI Travels. Une histoire riche d\'expérience et de confiance bâtie au fil des années avec une clientèle fidèle.',
    ourStoryP2: 'Notre mission : faciliter les déplacements de nos clients à travers le monde grâce à un service personnalisé, des partenariats solides avec les meilleures compagnies aériennes, et un accompagnement humain à chaque étape de votre voyage.',
    directorQuote: 'Chez IZI Travels, chaque client est unique. Notre engagement : transformer vos rêves de voyage en réalité avec professionnalisme et passion.',
    directorLabel: 'Directeur Général',
    directorTitle: 'Fondateur & DG de IZI Travels',
    honoraryDeputy: 'Député Honoraire',
    ceniMember: 'Membre Plénière CENI',

    // Payments
    paymentsBadge: 'Paiement simplifié',
    paymentsTitle: 'Plusieurs moyens de paiement',
    paymentsSubtitle: 'Réservez et payez sans vous déplacer — Mobile Money ou Virement bancaire',
    paymentsConvenience: 'Économisez votre temps, évitez les embouteillages',
    paymentsConvenienceDesc: 'Payez confortablement depuis chez vous ou votre bureau, sans déplacement à l\'agence.',
    mobileMoneyTitle: 'Mobile Money',
    mobileMoneyDesc: 'Paiement rapide et sécurisé depuis votre téléphone',
    bankTransferTitle: 'Virement bancaire',
    bankTransferDesc: 'Virement depuis votre banque ou plateforme préférée',
    paymentsFooter: 'Contactez-nous pour obtenir les coordonnées de paiement après confirmation de votre réservation.'
  },
  en: {
    // Header
    home: 'Home',
    destinations: 'Destinations',
    airlines: 'Airlines',
    services: 'Services',
    contact: 'Contact',
    about: 'About',
    payments: 'Payments',
    bookNow: 'Book Now',
    
    // Testimonials
    testimonialsBadge: 'Testimonials',
    testimonialsTitle: 'Trusted by our clients',
    testimonialsSubtitle: 'Discover the experiences of our clients traveling with IZI Travels',
    leaveReviewCTA: 'Leave a review',
    leaveReviewHelp: 'Have you traveled with us? Share your experience in seconds.',
    reviewModalTitle: 'Share your experience',
    reviewModalSubtitle: 'Your review helps other travelers discover us',
    reviewRating: 'Rating',
    reviewName: 'Your name',
    reviewTrip: 'Your trip',
    reviewEmail: 'Email',
    reviewMessage: 'Your testimonial',
    reviewSubmit: 'Send my review',
    reviewSubmitting: 'Sending...',
    reviewModerationNote: 'Your review will be published after validation by our team.',
    reviewThanksTitle: 'Thank you!',
    reviewThanksMsg: 'Your review was sent successfully. It will be published after validation by our team.',
    optional: 'optional',
    close: 'Close',
    
    // Hero
    premiumAgency: 'Premium Travel Agency',
    heroTitle: 'Travel anywhere in the world with',
    heroSubtitle: 'National and international tickets — all destinations, all airlines.',
    discoverDestinations: 'Discover destinations',
    
    // Destinations
    ourDestinations: 'Our Destinations',
    destinationsSubtitle: 'Explore all possible destinations — national, African and international',
    all: 'All',
    national: 'National',
    african: 'African',
    international: 'International',
    
    // Airlines
    ourPartners: 'Our Partner Airlines',
    airlinesSubtitle: 'We work with the best airlines to offer you quality service',
    moreAirlines: 'And many other airlines serving N\'djili International Airport',
    
    // Services
    ourServices: 'Our Services',
    servicesSubtitle: 'A complete range of services to make your travel experience exceptional',
    service1Title: 'Flight ticket booking',
    service1Desc: 'Book your national and international tickets with ease',
    service2Title: 'National and international travel',
    service2Desc: 'Access all destinations around the world',
    service3Title: 'Travel assistance',
    service3Desc: 'Personalized support at every stage of your journey',
    service4Title: 'Advice and support',
    service4Desc: 'Experts at your service to plan your perfect trip',
    service5Title: 'Quick bookings',
    service5Desc: 'A simple and efficient booking process',
    service6Title: 'Responsive customer service',
    service6Desc: 'Available 7 days a week to answer your questions',
    
    // Booking Form
    bookYourTrip: 'Book Your Trip',
    bookingSubtitle: 'Fill out the form below and our team will contact you shortly',
    tripType: 'Trip Type',
    oneWay: 'One Way',
    roundTrip: 'Round Trip',
    multiCity: 'Multi-City',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    fromCity: 'Departure City',
    toCity: 'Destination City',
    departureDate: 'Departure Date',
    returnDate: 'Return Date',
    yourRequest: 'Your Request',
    sendRequest: 'Send Request',
    namePlaceholder: 'Your name',
    emailPlaceholder: 'your@email.com',
    phonePlaceholder: '+243 XXX XXX XXX',
    fromPlaceholder: 'E.g: Kinshasa',
    toPlaceholder: 'E.g: Paris',
    messagePlaceholder: 'Describe your travel needs...',
    successMessage: 'Request sent successfully! We will contact you soon.',
    
    // Passengers
    passengers: 'Passengers',
    adults: 'Adults',
    adultsDesc: '12 years and older',
    children: 'Children',
    childrenDesc: '2 to 11 years',
    infants: 'Infants',
    infantsDesc: 'Under 2 years',
    minAdultError: 'At least one adult is required',
    maxAdultError: 'Maximum 9 adults per booking',
    infantsExceedError: 'Number of infants cannot exceed number of adults',
    childrenNeedAdultError: 'Children must travel with an adult',
    
    // Multi-city fields
    flight: 'Flight',
    from: 'From',
    to: 'To',
    date: 'Date',
    addFlight: 'Add Flight',
    removeFlight: 'Remove Flight',
    
    // Contact
    contactUs: 'Contact Us',
    contactSubtitle: 'Our team is available to answer all your questions',
    address: 'Address',
    telephone: 'Phone',
    
    // Footer
    tagline: 'Your gateway to the world. Travel with confidence and style.',
    quickLinks: 'Quick Links',
    ourServicesFooter: 'Our Services',
    nationalTickets: 'National Tickets',
    internationalTickets: 'International Tickets',
    travelAssistance: 'Travel Assistance',
    personalizedAdvice: 'Personalized Advice',
    quickBooking: 'Quick Booking',
    allRightsReserved: 'All rights reserved.',
    footerSignature: 'IZI Travels — Your gateway to the world.',

    // About
    aboutBadge: 'Our Story',
    aboutTitle: 'About IZI Travels',
    aboutSubtitle: 'Over two decades of expertise at your service',
    yearsExperience: 'Years of experience',
    clientsServed: 'Happy clients',
    destinationsCount: 'Destinations',
    airlinePartners: 'Airline partners',
    ourStoryTitle: 'Proven expertise for over 20 years',
    ourStoryP1: 'IZI Travels has been operating for over 20 years, originally under the name BM Travels and now as IZI Travels. A rich history of experience and trust built over the years with loyal clientele.',
    ourStoryP2: 'Our mission: facilitate our clients\' travels around the world through personalized service, strong partnerships with the best airlines, and human support at every step of your journey.',
    directorQuote: 'At IZI Travels, every client is unique. Our commitment: turning your travel dreams into reality with professionalism and passion.',
    directorLabel: 'Director General',
    directorTitle: 'Founder & CEO of IZI Travels',
    honoraryDeputy: 'Honorary Deputy',
    ceniMember: 'CENI Plenary Member',

    // Payments
    paymentsBadge: 'Simplified Payment',
    paymentsTitle: 'Multiple payment methods',
    paymentsSubtitle: 'Book and pay without leaving home — Mobile Money or Bank Transfer',
    paymentsConvenience: 'Save time, avoid traffic jams',
    paymentsConvenienceDesc: 'Pay comfortably from home or office, no need to visit the agency.',
    mobileMoneyTitle: 'Mobile Money',
    mobileMoneyDesc: 'Fast and secure payment from your phone',
    bankTransferTitle: 'Bank Transfer',
    bankTransferDesc: 'Transfer from your preferred bank or platform',
    paymentsFooter: 'Contact us to get payment details after confirming your booking.'
  }
};
